export default __webpack_public_path__ + "static/media/283.21bc5182.gif";